import React, { useState } from "react";
import { Modal } from 'bootstrap';
import { formatDate, formatDateTime } from "../../components/DateUtil";
import clientHttp from '../../components/ClientHttp';
import { useNavigate } from "react-router-dom";

export default function OrderPaymentList({ fromDate, toDate, data, totalOrderPaid, totalOrderNotPaid, totalPaymentPaid, totalPaymentNotPaid }) {
    console.log('Date: ' + fromDate + ', ' + toDate)
    let navigate = useNavigate()
    // payment detail
    const [paymentDetailList, setPaymentDetailList] = useState(null)
    const [paymentId, setPaymenetId] = useState(null)
    const [orderDate, setOrderDate] = useState(null)
    const [orderNo, setOrderNo] = useState(null)
    const [openPopup, setOpenPopup] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    // background color for payment detail
    let bgColorMap = JSON.parse('{"2C2P":"#B4C6E7","MAGIC":"#F8CBAD","AMWAY":"#C6E0B4","KBANK":"#FFFFFF"}')
    console.log(bgColorMap)

    async function handlePaymentDetail(order) {
        if (!openPopup) {
            return;
        }
        // prevent double click
        //setOpenPopup(false)
        setIsLoading(true)

        let orderDetailListModal = new Modal('#orderDetailListModal')
        orderDetailListModal.show()
        setOpenPopup(true)

        setPaymentDetailList(null)
        setOrderNo(order.order_id)
        setPaymenetId(order.payment_id)
        setOrderDate(order.order_date)

        console.log('find payment detail of payment id: ' + order.payment_id)
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/orderpaymentdetaillist', { paymentId: order.payment_id }, {
            headers: { 'Authorization': 'Bearer ' + token }
        }).then(response => {
            setIsLoading(false)

            console.log('response status: ' + response.status)
            if (response.data.status === 'success') {
                console.log('display payment detail')
                setPaymentDetailList(response.data.data)
            } else {
                console.log('get payment detail failed: ' + response.data.message)
            }

        }).catch(err => {
            setIsLoading(false)
            
            console.log('error: ', err.message)
            if (err.response.status === 401 || err.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get payment detail failed: ' + err.message)
            }
        })

        //let orderDetailListModal = new Modal('#orderDetailListModal')
        //orderDetailListModal.show()
        //setOpenPopup(true)
    }

    return (
        <>
            <div>
                <span><b>Order paid:</b> {totalOrderPaid}</span>
                <span className="ms-3"><b>Order not paid:</b> {totalOrderNotPaid}</span>
                <span className="ms-5"><b>Payment paid:</b> {totalPaymentPaid}</span>
            </div>
            <div id="orderPaymentList" className="table-responsive table-hover table-sales text-nowrap">
                <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Order Date</th>
                            <th scope="col">Order ID</th>
                            <th scope="col">ABO No</th>
                            <th scope="col">Party ID</th>
                            <th scope="col">Sales Channel</th>
                            <th scope="col">Order Status</th>
                            <th scope="col" className="text-end">Amount</th>
                            <th scope="col">Payment ID</th>
                            <th scope="col">Payment Status</th>
                            <th scope="col"> </th>
                            <th scope="col">Payment Date</th>
                            <th scope="col">Payment ID</th>
                            <th scope="col">Payment Status</th>
                            <th scope="col">Order ID</th>
                            <th scope="col" className="text-end">Paid Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((order) => {
                                let classStatus = order.order_payment_status !== order.payment_status ? 'text-center table-warning' : 'text-center'

                                return (
                                    <tr key={order.order_id}>
                                        <td>{formatDate(new Date(order.order_date))}</td>
                                        <td>{order.order_id}</td>
                                        <td>{order.abo_no}</td>
                                        <td>{order.party_id}</td>
                                        <td>{order.sales_channel}</td>
                                        <td className="text-center">{order.order_status}</td>
                                        <td className="text-end">{
                                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                                .format(order.amount).replace("USD", "").trim()}</td>
                                        <td>
                                            {order.payment_id !== '' ?
                                            <button type="button" title="Payment Detail" className="btn btn-link link-primary link-offset-2 link-underline link-underline-opacity-0" onClick={handlePaymentDetail.bind(this, order)}>
                                                <i className="bi bi-view-list"></i>
                                            </button> : <></>
                                            }
                                            {order.order_payment_id}
                                        </td>
                                        <td className={classStatus}>{order.order_payment_status}</td>
                                        <td></td>
                                        <td>{formatDate(new Date(order.payment_date))}</td>
                                        <td>{order.payment_id}</td>
                                        <td className={classStatus}>{order.payment_status}</td>
                                        <td>{order.payment_order_id}</td>
                                        <td className="text-end">{
                                            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                                .format(order.paid_amount).replace("USD", "").trim()}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>

            {/* order detail list ; modal-dialog-centered */}
            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="orderDetailListModal" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" style={{ "max-width": "90%" }} role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalCenterTitle">Payment Details</h5>
                                </div>

                                {isLoading && (
                                    <div className="d-flex justify-content-center m-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>            
                                )}

                                {!isLoading && paymentDetailList !== null && (
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-1"><b>Payment ID:</b></div>
                                        <div className="col-md-5">{paymentId}</div>
                                        <div className="col-md-1"><b>Order Date:</b></div>
                                        <div className="col-md-5">{formatDate(new Date(orderDate))}</div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-1"><b>Order No:</b></div>
                                        <div className="col-md-5">{orderNo}</div>
                                        <div className="col-md-6"></div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">Payment Date</th>
                                                        <th scope="col" className="text-end">Payment Value</th>
                                                        <th scope="col">Payment Status</th>
                                                        <th scope="col">Payment Transaction status</th>
                                                        <th scope="col">Payment Type</th>
                                                        <th scope="col">Payment Method</th>
                                                        <th scope="col" className="text-center">Merchant ID</th>
                                                        <th scope="col">Sales Channel Code</th>
                                                        <th scope="col">Payment Provider</th>
                                                        <th scope="col">Payment Transaction Id</th>
                                                        <th scope="col">Source Event Id</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        paymentDetailList?.map((item, index) => {
                                                            //let classStatus = order.order_payment_status !== order.payment_status ? 'text-center table-warning' : 'text-center'
                                                            let bgColor = bgColorMap[item.payment_provider] ? bgColorMap[item.payment_provider] : '#FFFFFF'

                                                            return (
                                                                <tr key={index} style={{"backgroundColor": bgColor}}>
                                                                    <td>{formatDateTime(new Date(item.payment_date))}</td>
                                                                    <td className="text-end">{
                                                                        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'code' })
                                                                            .format(item.payment_value).replace("USD", "").trim()}</td>
                                                                    <td>{item.payment_status}</td>
                                                                    <td>{item.payment_trans_status}</td>
                                                                    <td>{item.payment_trans_type}</td>
                                                                    <td>{item.payment_method}</td>
                                                                    <td className="text-center">{item.merchant_id}</td>
                                                                    <td>{item.sales_channel_code}</td>
                                                                    <td style={{"backgroundColor": bgColor}}>{item.payment_provider}</td>
                                                                    <td>{item.payment_trans_id}</td>
                                                                    <td>{item.source_event_id}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                                )}

                                <div className="modal-footer text-center">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
